<div class="flex min-w-0 flex-col gap-4">
  @if (filters.length > 1) {
    <div class="crm-scroll flex items-center gap-4 overflow-x-auto border-b border-slate-200">
      @for (filter of filters; track filter) {
        <button
          type="button"
          class="shrink-0 whitespace-nowrap border-b-2 px-1 pb-2 text-sm font-semibold transition"
          [class.border-orange-500]="activeFilter === filter"
          [class.text-slate-950]="activeFilter === filter"
          [class.border-transparent]="activeFilter !== filter"
          [class.text-slate-400]="activeFilter !== filter"
          (click)="selectFilter(filter)"
        >
          {{ FILTER_OPTIONS[filter].labelKey | translate }}
        </button>
      }
    </div>
  }

  <section class="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
    @if (showHeader) {
      <div class="mb-3 flex items-center justify-between border-b border-slate-100 pb-3">
        <h2 class="m-0 text-base font-semibold text-slate-950">{{ 'timeline' | translate }}</h2>
      </div>
    }

    @if (!loaded) {
      <div class="flex flex-col gap-3">
        <div class="h-16 animate-pulse rounded-lg bg-slate-50"></div>
        <div class="h-16 animate-pulse rounded-lg bg-slate-50"></div>
        <div class="h-16 animate-pulse rounded-lg bg-slate-50"></div>
      </div>
    } @else if (!events.length) {
      <div class="flex min-h-32 items-center justify-center rounded-lg bg-slate-50 text-sm text-slate-400">
        {{ 'no_timelines' | translate }}
      </div>
    } @else {
      <div class="flex flex-col gap-3">
        @for (event of events; track event.id) {
          @if (isEntityShown && getEntityLink(event); as link) {
            <div class="-mb-2 flex min-w-0">
              <app-button
                btnType="no-btn"
                [disabled]="!link.canOpen"
                [customClass]="
                  'inline-flex max-w-full items-center gap-1 rounded-md px-1 py-0.5 text-xs font-medium text-slate-500 ' +
                  (link.canOpen ? 'cursor-pointer hover:bg-slate-100 hover:text-orange-600' : 'cursor-default')
                "
                (onChangeClick)="openEntity(event)"
              >
                <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">{{ link.icon }}</app-icon>
                <span class="shrink-0">{{ link.typeKey | translate }}</span>
                @if (link.name) {
                  <span class="truncate text-slate-700" [class.line-through]="link.deleted">· {{ link.name }}</span>
                }
                @if (link.deleted) {
                  <span class="shrink-0 text-slate-400">({{ 'timeline_entity_deleted' | translate | lowercase }})</span>
                }
                @if (link.canOpen) {
                  <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">open_in_new</app-icon>
                }
              </app-button>
            </div>
          }
          @if (event.event_type === CardTimelineEventType.REMINDER) {
            <app-board-v3-timeline-reminder
              [cardId]="getCardId(event)"
              [event]="event"
              [canPrefill]="canPrefillReminders"
              (repeat)="repeatReminder.emit($event)"
              (edit)="editReminder.emit($event)"
            />
          } @else if (event.event_type === CardTimelineEventType.COMMENT) {
            <app-board-v3-timeline-comment
              [cardId]="getCardId(event)"
              [event]="event"
              [readonly]="!getCardId(event)"
              (commentChanged)="reload()"
            />
          } @else if (event.event_type === CardTimelineEventType.CALL) {
            <app-board-v3-timeline-call [event]="event" (callChanged)="reload()" />
          } @else {
            <app-board-v3-timeline-update
              [event]="event"
              [fieldDefinitions]="fieldDefinitions"
              [cardCurrency]="cardCurrency"
              (contactChanged)="contactChanged.emit($event)"
              (companyChanged)="companyChanged.emit($event)"
            />
          }
        }
      </div>

      @if (hasMore) {
        <div class="mt-3 flex justify-center">
          <app-button btnType="stroked" [disabled]="loading" (onChangeClick)="loadMore()">
            {{ 'upload_more' | translate }}
          </app-button>
        </div>
      }
    }
  </section>
</div>
